<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Add Schedule</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      <mat-form-field class="flex-full">
        <mat-label>Name</mat-label>
        <input matInput autocomplete="off" type="text" formControlName="name" id="name" required />
        @if (form.get('name')?.hasError('required')) {
          <mat-error> Name is required. </mat-error>
        }
        @if (form.get('name')?.hasError('maxlength')) {
          <mat-error> Name limited to 255 characters. </mat-error>
        }
        @if (form.get('name')?.hasError('pattern')) {
          <mat-error>
            Invalid Name. Name may include letters, numbers, and characters. No leading/trailing spaces.
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="flex-full">
        <mat-label>Description</mat-label>
        <input matInput autocomplete="off" type="text" formControlName="description" id="description" />
        @if (form.get('description')?.hasError('pattern')) {
          <mat-error>
            Invalid Description. Description may include letters, numbers, and characters. No leading/trailing
            spaces.
          </mat-error>
        }
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button type="submit" title="Create" mat-raised-button>Save</button>
    </mat-dialog-actions>
  </form>
</lcs-loading-overlay>
